<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_10"></a><a id="part01"></a><span class="smallcaps">PART</span> I<br/>STANDING ON THE EDGE OF HELL</h2>
<p class="image"><img alt="Image" src="images/f0010-01.jpg"/></p>
<p class="image"><a id="page_11"></a> <img alt="Image" src="images/f0011-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?83e71e64